import { useQuery } from '@tanstack/react-query';
import { getTopIssueCategories } from '../services/AnalyticReportsService';
export default function useTopIssueCategories(filters) {
    return useQuery(['topIssueCategories', filters.values.dateRange], () => getTopIssueCategories(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
